<template>
  <div class="not-found-container">
    <div class="not-found">
      <div v-if="projectLink" class="home-button is-hidden-desktop" @click="goHome"> Home <span><i class="fal fa-chevron-right"></i></span></div>
      <div class="title is-4 is-marginless">{{$t('search.notFound')}}
      </div>
      <span class="subtitle">{{$t('search.checkOut')}} <span v-if="loading" class="loader"></span></span>
      <div v-if="!loading" class="projects-container">
        <div class="projects">
          <contribution-card :linkedProject="project" v-for="project in projects" :key="project.id"></contribution-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContributionCard from '@/components/Cards/ProjectCards/Types/Contributions'

export default {
  components: {
    ContributionCard
  },
  props: ['projectLink'],
  data: function () {
    return {
      loading: false,
      projects: []
    }
  },
  mounted: function () {
    this.findProjects()
  },
  methods: {
    findProjects: function () {
      this.loading = true
      this.$store.dispatch('getProjects', { limit: 4, page: 1, sort: 'random' }).then((response) => {
        this.projects = response.projects
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    goHome: function () {
      this.$router.push({ name: 'home' })
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~styles/utils.scss";

  .title {
    padding: 3rem 1rem 1rem 2rem;
    @include touch {
      padding-left: 1rem;
      font-size: 1.2rem;
    }
  }

  .subtitle {
    padding-left: 2rem;
    @include touch {
      padding-left: 1rem;
      font-size: 0.8rem;
    }
  }

  .loader {
    display: inline-block
  }

  .not-found-container {
    position: absolute;
    top: 52px; // height of nav
    left: 0;
    display: flex;
    justify-content: center;
    width: 100vw;
  }

  .not-found {
    width: 100vw;
    max-width: 1200px;
    height: calc(100vh - 52px);
    padding: 0 1rem 0;
    background-color: white;
    @include mobile {
      padding: 0;
    }
  }

  .projects {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    @include mobile {
      width: 100vw;
      padding: 0;
    }
    .column{
      padding:2rem 1.8rem 1rem 30px;
      @include mobile {
         padding: 1rem 0;
      }
    }
  }

  .projects .column:last-child {
    @include desktop {
      display: none;
    }
  }

  .home-button {
    margin-left: 1rem;
    color: $primary;
    font-weight: 600;
    margin-top: 0.5rem;
  }

  i {
    font-size: 0.8rem;
  }
</style>
